import { VeFiles } from "@tm/data"
import { useCallback } from "react"
import { useMutation, useQueryClient } from "react-query"
import { channel } from "@tm/models"
import { useLocalization } from "@tm/localization"
import { QueryKeys } from "."

export function useFileDelete() {
    const queryClient = useQueryClient()
    const { translateText } = useLocalization()

    const { isLoading, mutateAsync } = useMutation(VeFiles.deleteFiles)

    const deleteFile = useCallback(
        async (request: string | string[]) => {
            const result = await mutateAsync(Array.isArray(request) ? request : [request])

            if (result?.isDeleted) {
                queryClient.invalidateQueries([QueryKeys.GetFileList])
                channel("APP").publish("TOAST_MESSAGE/SHOW", {
                    message: translateText(14033),
                    icon: "check",
                    skin: "success",
                    closeDelay: 3000,
                })
            } else {
                channel("APP").publish("TOAST_MESSAGE/SHOW", {
                    message: translateText(14034),
                    icon: "error",
                    skin: "warning",
                    closeDelay: 3000,
                })
            }
            return result
        },
        [mutateAsync, queryClient, translateText]
    )
    return { isLoading, deleteFile }
}
